var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "main-body"
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "12px"
    }
  }, [_vm._v("修改密码")]), _c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "旧密码",
      "prop": "oldPassword"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "输入旧密码"
    },
    on: {
      "on-blur": _vm.validatPasswordMethod
    },
    model: {
      value: _vm.formItem.oldPassword,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "oldPassword", $$v);
      },
      expression: "formItem.oldPassword"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "新密码",
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "输入新密码"
    },
    on: {
      "on-enter": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    },
    model: {
      value: _vm.formItem.password,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "password", $$v);
      },
      expression: "formItem.password"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("修改")])], 1)], 1), _c('div', {
    staticClass: "tip"
  }, [_vm._v("注：首次登陆需要重置初始密码")])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }